import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b26779f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-center mt-2" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Søg kunde")
  ])
], -1))
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "row"
}
const _hoisted_12 = { class: "form-check header" }
const _hoisted_13 = ["checked", "onChange"]
const _hoisted_14 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_15 = { class: "form-check subitem" }
const _hoisted_16 = ["onUpdate:modelValue", "disabled", "onChange"]
const _hoisted_17 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_18 = {
  key: 0,
  class: "row"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-center" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "text-danger" }, "Fejl: Kundeoplysningerne kunne ikke findes")
], -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_b_icon_search = _resolveComponent("b-icon-search")!
  const _component_LaravelPagination = _resolveComponent("LaravelPagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TextInput, {
            label: 'Search',
            modelValue: _ctx.searchString,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchString) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary search-button",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, [
            _createTextVNode(" Søg "),
            _createVNode(_component_b_icon_search)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h4", null, [
            _createTextVNode("Søg i: "),
            (_ctx.fieldsToSearch === false)
              ? (_openBlock(), _createElementBlock("small", _hoisted_7, "Ingen felter valgt"))
              : _createCommentVNode("", true)
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchableFields, (table, tableIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass({'col-6': _ctx.searchableFields.length == 2, 'col-4': _ctx.searchableFields.length == 3, 'col-3': _ctx.searchableFields.length>=4})
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        name: "tableSelector",
                        type: "radio",
                        value: true,
                        checked: _ctx.searchableFields[tableIndex].selected,
                        onChange: ($event: any) => (_ctx.tableChange(_ctx.searchableFields[tableIndex]))
                      }, null, 40, _hoisted_13),
                      _createElementVNode("label", _hoisted_14, [
                        _createElementVNode("b", null, _toDisplayString(table.name), 1)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.fields, (field, fieldsIndex) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          value: "",
                          id: "flexCheckDefault",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.searchableFields[tableIndex].fields[fieldsIndex].selected) = $event),
                          disabled: !_ctx.searchableFields[tableIndex].selected,
                          onChange: ($event: any) => (_ctx.fieldChange(_ctx.searchableFields[tableIndex], _ctx.searchableFields[tableIndex].fields[fieldsIndex]))
                        }, null, 40, _hoisted_16), [
                          [_vModelCheckbox, _ctx.searchableFields[tableIndex].fields[fieldsIndex].selected]
                        ]),
                        _createElementVNode("label", _hoisted_17, _toDisplayString(field.name), 1)
                      ]))
                    }), 256))
                  ], 2))
                }), 256))
              ]))
        ])
      ])
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
      : _createCommentVNode("", true),
    (_ctx.searchString != '')
      ? (_openBlock(), _createBlock(_component_LaravelPagination, {
          key: 1,
          ref: "paginationRef",
          query: _ctx.searchString,
          config: _ctx.config,
          multiple: false,
          onSelected: _ctx.goTo
        }, null, 8, ["query", "config", "onSelected"]))
      : _createCommentVNode("", true)
  ], 64))
}